export default {
  title: 'Surveys',
  subtitle: 'Campaign management and results',

  audiences: {
    STUDENTS: 'Students',
    TEACHERS: 'Teachers',
    DATA_SYSTEM: 'Data System',
  },

  campaigns: {
    title: 'Campaigns',
    new: 'New campaign',
    edit: 'Edit campaign',
    empty: 'There are no campaigns for this audience yet',
    col_name: 'Name',
    col_starts_at: 'From',
    col_ends_at: 'To',
    col_status: 'Status',
    col_responses: 'Responses',
    col_countries: 'Countries',
    col_actions: 'Actions',
    all_countries: 'All countries',
    status: {
      ACTIVE: 'Active',
      SCHEDULED: 'Scheduled',
      FINISHED: 'Finished',
      INACTIVE: 'Inactive',
    },
    form: {
      name: 'Name',
      starts_at: 'Start date',
      ends_at: 'End date',
      dates_hint: 'The survey is shown while today falls within the range.',
      countries: 'Countries',
      countries_hint: 'Leave empty to target the campaign to all countries.',
      save: 'Save',
      cancel: 'Cancel',
      required: 'This field is required',
      dates_order: 'The start date cannot be after the end date',
    },
    delete: {
      title: 'Delete campaign',
      confirm: 'Delete the campaign "{name}"? This cannot be undone.',
      accept: 'Delete',
      cancel: 'Cancel',
      has_responses: 'A campaign that already has responses cannot be deleted.',
    },
    created: 'Campaign created',
    updated: 'Campaign updated',
    deleted: 'Campaign deleted',
    overlap: 'The dates overlap with another campaign for the same audience.',
    deactivate: {
      title: 'Deactivate campaign',
      confirm: 'Deactivate the campaign "{name}"? It will stop accepting new responses, but historical data is kept.',
      accept: 'Deactivate',
      cancel: 'Cancel',
    },
    activated: 'Campaign activated',
    deactivated: 'Campaign deactivated',
  },

  export: {
    button: 'Export CSV',
    col_score: 'Score',
    col_count: 'Count',
    col_percentage: 'Percentage',
    negative_only: 'Negative only',
  },

  results: {
    title: 'Results: {name}',
    no_campaign: 'Select a campaign to see its results',
    no_data: 'This campaign has no responses yet',
    load_error: 'Results could not be loaded. Please try again.',
    filter_country: 'Country',
    filter_school: 'School',
    filter_all: 'All',
  },

  nps: {
    score: 'NPS',
    responses: 'Responses',
    average: 'Average score',
    promoters: 'Promoters',
    passives: 'Passives',
    detractors: 'Detractors',
    distribution_title: 'Score distribution',
    breakdown_title: 'Results by segment',
    by_school: 'School',
    by_country: 'Country',
    col_segment: 'Segment',
    col_responses: 'Responses',
    col_nps: 'NPS',
    col_average: 'Average',
    comments_title: 'Comments',
    comments_empty: 'This campaign has no comments',
    comments_empty_negative: 'This campaign has no negative comments',
    col_user: 'User',
    col_score: 'Score',
    col_comment: 'Comment',
    col_school: 'School',
    col_country: 'Country',
    col_date: 'Date',
  },
};
